module.exports = __webpack_public_path__ + "img/mail-icon.82d943fb93e4191918436d26ac4f48d3.svg";